<template>
  <div class="bg-darkblue-400 h-px w-full"></div>
</template>
<script>
export default {
  name: 'Separator'
}
</script>